export default __webpack_public_path__ + "static/media/zksync-logo.bc42312f.svg";